exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding{\n  padding: 0px\n}\nh3.box-title {\n  margin-bottom: 15px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/timesheets/import-timesheet/import-timesheet.component.css
// module id = ../../../../../src/app/timesheets/import-timesheet/import-timesheet.component.css
// module chunks = main